import React from 'react';

import { VideoOnIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

import { CheckTypeCard } from './CheckTypeCard';
import st from './shared.module.sass';

const VideoTypeCard = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <CheckTypeCard
      icon={<VideoOnIcon />}
      iconClassName={st.VideoIconBg}
      onClick={onClick}
      title={t('checks:check type card.video.title')}
      subtitle={t('checks:check type card.video.subtitle')}
    />
  );
};

export default VideoTypeCard;
